<div class="mj-section-header">
  <p class="mj-section-header__surtitle">{{ surtitle }}</p>
  <h2 class="mj-section-header__title">{{ title }}</h2>
</div>
